
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ContactUsApi } from "../../services/contactUsService"

export const createContactUsMessage = createAsyncThunk(
    'contactUs/createContactUsMessage',
    async (formData, { rejectWithValue }) => {
        try {
        const data = await ContactUsApi.createContactUsMessage(formData);
        return data;
        } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
    );

    export const getListContactUsMessages = createAsyncThunk(
        'contactUs/getListContactUsMessages',
        async (_, { rejectWithValue }) => {
            try {
                const data = await ContactUsApi.getListContactUsMessages();
                return data;
            } catch (error) {
                return rejectWithValue(error.response?.data?.message || error.message);
            }
        }
    );
    
    export const searchContactUsMessages = createAsyncThunk(
        'contactUs/searchContactUsMessages',
        async (searchTerm, { rejectWithValue }) => {
            try {
                const data = await ContactUsApi.searchContactUsMessages(searchTerm);
                return data;
            } catch (error) {
                return rejectWithValue(error.response?.data?.message || error.message);
            }
        }
    );
    
    export const deleteContactUsMessage = createAsyncThunk(
        'contactUs/deleteContactUsMessage',
        async (messageId, { rejectWithValue }) => {
            try {
                const data = await ContactUsApi.deleteContactUsMessage(messageId);
                return data;
            } catch (error) {
                return rejectWithValue(error.response?.data?.message || error.message);
            }
        }
    );
    
    export const getSingleContactUsMessage = createAsyncThunk(
        'contactUs/getSingleContactUsMessage',
        async (messageId, { rejectWithValue }) => {
            try {
                const data = await ContactUsApi.getSingleContactUsMessage(messageId);
                return data;
            } catch (error) {
                return rejectWithValue(error.response?.data?.message || error.message);
            }
        }
    );
    
    export const updateContactUsMessage = createAsyncThunk(
        'contactUs/updateContactUsMessage',
        async (formData, { rejectWithValue }) => {
            try {
                const data = await ContactUsApi.updateContactUsMessageStatus(formData);
                return data;
            } catch (error) {
                return rejectWithValue(error.response?.data?.message || error.message);
            }
        }
    );
    
    // Slice
    const contactUsSlice = createSlice({
        name: "contactUs",
        initialState: {
            loading: false,
            error: null,
            data: null,
            messages: [],
            singleMessage: null,
        },
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(createContactUsMessage.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(createContactUsMessage.fulfilled, (state, action) => {
                    state.loading = false;
                    state.data = action.payload;
                })
                .addCase(createContactUsMessage.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
                .addCase(getListContactUsMessages.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(getListContactUsMessages.fulfilled, (state, action) => {
                    state.loading = false;
                    state.messages = action.payload;
                })
                .addCase(getListContactUsMessages.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
                .addCase(searchContactUsMessages.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(searchContactUsMessages.fulfilled, (state, action) => {
                    state.loading = false;
                    state.messages = action.payload;
                })
                .addCase(searchContactUsMessages.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
                .addCase(deleteContactUsMessage.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(deleteContactUsMessage.fulfilled, (state, action) => {
                    state.loading = false;
                    state.messages = state.messages.filter(
                        (message) => message.id !== action.meta.arg
                    );
                })
                .addCase(deleteContactUsMessage.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
                .addCase(getSingleContactUsMessage.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(getSingleContactUsMessage.fulfilled, (state, action) => {
                    state.loading = false;
                    state.singleMessage = action.payload;
                })
                .addCase(getSingleContactUsMessage.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                })
                .addCase(updateContactUsMessage.pending, (state) => {
                    state.loading = true;
                    state.error = null;
                })
                .addCase(updateContactUsMessage.fulfilled, (state, action) => {
                    state.loading = false;
                    state.singleMessage = action.payload;
                })
                .addCase(updateContactUsMessage.rejected, (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                });
        },
    });
    
    export default contactUsSlice.reducer;